import React, { useState } from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import Remarks from '../helpers/Remarks/Remarks';
import { hasValidContent } from '@shared/pages/Hotels/helpers/Remarks/hasValidContent';

const BookingRemarks = ({ room, hotelsValidateResult, cancelationFee }) => {
  const [open, setOpen] = useState(false);

  const hasRemarks =
    hasValidContent(room?.general_comments) ||
    hasValidContent(cancelationFee?.general_comments) ||
    hasValidContent(hotelsValidateResult?.comments) ||
    hasValidContent(hotelsValidateResult?.remarks);

  if (!hasRemarks) return null;

  return (
    <Accordion
      expanded={open}
      onChange={(_, expanded) => setOpen(expanded)}
      sx={{
        backgroundColor: 'transparent',
        boxShadow: 'none',
        m: 0,
        mt: '10px',
        border: 'none',
        '&:before': { display: 'none' },
        '& .MuiAccordionSummary-root': {
          borderBottom: 'none',
        },
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={{
          p: 0,
          minHeight: 'auto',
          '& .MuiAccordionSummary-content': {
            margin: 0,
          },
          '& .MuiAccordionSummary-content.Mui-expanded': {
            margin: 0,
          },
          '&.Mui-expanded': {
            minHeight: 30,
          },
        }}
      >
        <Typography
          sx={{
            fontSize: '14px',
            fontWeight: 500,
          }}
        >
          Observaciones
        </Typography>
      </AccordionSummary>

      <AccordionDetails sx={{ p: 0 }}>
        <Remarks
          room={room}
          hotelsValidateResult={{
            remarks: hotelsValidateResult?.remarks,
            comments: hotelsValidateResult?.comments,
          }}
          buttonClose={false}
          cancelationFee={cancelationFee}
        />
      </AccordionDetails>
    </Accordion>
  );
};

export default BookingRemarks;
